// Domain and Route Configuration
export const DOMAIN_NAME = 'clientManagement';
export const CLIENT_ROUTE_ID = 40;

// API Endpoints
export const API_ENDPOINTS = {
    GET_ALL: '/client/get/all',
    GET_BY_ID: '/client/get',       // /client/get/:id
    GET_DETAIL: '/client/get',      // /client/get/:id/detail
    CREATE: '/client/create',
    UPDATE: '/client/update',       // /client/update/:id
    DELETE: '/client/delete',       // /client/delete/:id
    // Nested (prefixed with /client/:id)
    WEBSITES: 'websites',
    PERIODS: 'periods',
    GIT_REPOS: 'git-repos',
    STACKS: 'stacks',
    EMPLOYEES: 'employees',
    TEAMS: 'teams',
    // Dropdowns
    GET_TEAMS: '/team/get/all'
};

export const CLIENT_TYPES = [
    { value: 'PERMANENT', label: 'Permanent' },
    { value: 'ADHOC', label: 'Ad-hoc' }
];

export const CLIENT_TYPE_FILTER_OPTIONS = [
    { value: '', label: 'All Types' },
    ...CLIENT_TYPES
];

export const ACTIVE_STATUS_FILTER_OPTIONS = [
    { value: '', label: 'All' },
    { value: 'true', label: 'Active' },
    { value: 'false', label: 'Inactive' }
];

export const TABLE_COLUMNS = [
    { id: 'name', label: 'Name', sortable: true, minWidth: 180 },
    { id: 'type', label: 'Type', sortable: true, minWidth: 100 },
    { id: 'industry', label: 'Industry', sortable: true, minWidth: 140 },
    { id: 'country', label: 'Country', sortable: true, minWidth: 120 },
    { id: 'memberCount', label: 'Members', sortable: true, minWidth: 100, align: 'center' },
    { id: 'minHours', label: 'Min Hours', sortable: true, minWidth: 100, align: 'center' },
    { id: 'isActive', label: 'Status', sortable: true, minWidth: 100, align: 'center' },
    { id: 'updatedAt', label: 'Updated At', sortable: true, minWidth: 140 },
    { id: 'actions', label: 'Actions', sortable: false, minWidth: 100, align: 'center' }
];

export const SORT_BY_OPTIONS = [
    { value: 'updatedAt', label: 'Updated At' },
    { value: 'createdAt', label: 'Created At' },
    { value: 'name', label: 'Name' },
    { value: 'type', label: 'Type' },
    { value: 'industry', label: 'Industry' },
    { value: 'country', label: 'Country' },
    { value: 'contactEmail', label: 'Contact Email' },
    { value: 'isActive', label: 'Status' },
    { value: 'memberCount', label: 'Members' },
    { value: 'minHours', label: 'Min Hours' }
];

export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100];
export const DEFAULT_PAGE_SIZE = 10;

export const getErrorMessage = (error, defaultMessage) => {
    if (error?.response?.data?.message && typeof error.response.data.message === 'string') {
        return error.response.data.message;
    }
    if (error?.message) return error.message;
    return defaultMessage;
};
